import {TOKENS} from '../../tokens'

export const input = {
  dark: {
    bgFocus: TOKENS.dark.contrast_50,
    bgError: TOKENS.dark.negative_25,
    borderHover: TOKENS.dark.contrast_100,
    borderFocus: TOKENS.dark.positive_700,
    borderError: TOKENS.dark.negative_300,
    borderErrorActive: TOKENS.dark.negative_500,
    placeholder: TOKENS.dark.contrast_500,
    icon: TOKENS.dark.positive_700,
    iconHover: TOKENS.dark.positive_900,
    iconFocus: TOKENS.dark.positive_700,
    iconError: TOKENS.dark.negative_500,
    suffixActive: TOKENS.dark.contrast_800,
  },
  light: {
    bgFocus: TOKENS.light.contrast_50,
    bgError: TOKENS.light.negative_25,
    borderHover: TOKENS.light.contrast_100,
    borderFocus: TOKENS.light.primary_500,
    borderError: TOKENS.light.negative_300,
    borderErrorActive: TOKENS.light.negative_500,
    placeholder: TOKENS.light.contrast_500,
    icon: TOKENS.light.contrast_500,
    iconHover: TOKENS.light.contrast_800,
    iconFocus: TOKENS.light.primary_500,
    iconError: TOKENS.light.negative_500,
    suffixActive: TOKENS.light.contrast_800,
  },
} as const
